/**
 * 분석 화면이 다루는 **축과 지표의 이름** — 화면이 고르고, 세는 일은 서버가 한다.
 *
 * ⚠️ `key` 는 서버의 옮김표(`server/moments/analytics-axes`)와 **같은 글자**여야 한다 — 어긋나면 축이 조용히 빠진다.
 * ⚠️ 새 축을 더하려면 여기와 그 표 둘 다에 적는다.
 */

/** 축 하나 — 무엇으로 나눌 것인가 */
export type AnalyticsAxis = {
  key: string;
  label: string;
  /** 값이 여럿 붙는 필드인가 — 한 글이 여러 칸에 들어가 «칸 합이 전체보다 클 수» 있다 */
  multi?: boolean;
};

/** 지표 하나 — 무엇을 셀 것인가 */
export type AnalyticsMetric = {
  key: string;
  label: string;
  /** 화면에 적을 때 붙는 꼬리 */
  unit?: string;
  /** 비율 지표인가 — 서버가 퍼센트로 준다 */
  ratio?: boolean;
};

export const ANALYTICS_AXES: AnalyticsAxis[] = [
  { key: 'source', label: '채널' },
  { key: 'account', label: '계정' },
  { key: 'day', label: '날짜' },
  { key: 'week', label: '주' },
  { key: 'month', label: '월' },
  { key: 'market', label: '시장(국가)' },
  { key: 'language', label: '언어' },
  { key: 'contentType', label: '컨텐츠 유형' },
  { key: 'brand', label: '브랜드(AI 판별)', multi: true },
  { key: 'concern', label: '피부 고민(AI 판별)', multi: true },
  { key: 'ingredient', label: '성분(AI 판별)', multi: true },
  { key: 'hashtag', label: '해시태그', multi: true },
];

export const ANALYTICS_METRICS: AnalyticsMetric[] = [
  { key: 'count', label: '게시물 수', unit: '건' },
  { key: 'view', label: '조회수' },
  { key: 'like', label: '좋아요' },
  { key: 'comment', label: '댓글' },
  { key: 'share', label: '공유' },
  { key: 'engagement', label: '반응률(좋아요+댓글 ÷ 조회)', unit: '%', ratio: true },
];

export function findAxis(key: string): AnalyticsAxis | null {
  return ANALYTICS_AXES.find((a) => a.key === key) ?? null;
}

export function findMetric(key: string): AnalyticsMetric | null {
  return ANALYTICS_METRICS.find((m) => m.key === key) ?? null;
}

/** 축을 안 골랐다는 뜻 — 열 축에서만 쓴다(한 줄로 접힌다) */
export const AXIS_NONE = '';
